/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { NavigationItem } from '@squiz/sds';
import { hasPermission } from '../HasPermission/HasPermission';
import { isFeatureEnabled } from '../IsFeatureEnabled/IsFeatureEnabled';

/**
 * Check any display conditions that are applied to a navigation item.
 * @returns Whether the screen can be displayed.
 */
export const checkScreenCondition = (item: NavigationItem): boolean => {
  const { featureFlag, permission } = item;

  // If a certain permission level is required but not met, don't allow access
  if (permission && !hasPermission(permission)) {
    return false;
  }

  // If a feature flag controls access to the screen,
  // but it isn't enabled, don't allow access
  if (featureFlag && !isFeatureEnabled(featureFlag)) {
    return false;
  }

  // If no barriers are met, allow access to the screen
  return true;
};
